module.exports = __webpack_public_path__ + "static/media/proj1_img1.d51561f5.jpg";